// src/utils/errors.js
//
// FastAPI returns `detail` as a plain string for most errors, but as an
// array of Pydantic validation-error objects ({type, loc, msg, input, ctx})
// for 422s. Rendering that array directly in JSX crashes React ("Objects
// are not valid as a React child"). Use this anywhere an API error message
// is displayed to normalize either shape into a readable string.
export const getErrorMessage = (err, fallback = 'Something went wrong. Please try again.') => {
    const detail = err?.response?.data?.detail;
    if (!detail) return fallback;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
        return detail
            .map(d => (typeof d === 'string' ? d : d?.msg || JSON.stringify(d)))
            .join('; ');
    }
    return fallback;
};
